import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2026-05-25 21:18:10 +0200 (Mon, 25 May 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 163265 $
//  Purpose   : config editors
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Table, Icon, Menu } from 'semantic-ui-react';
// ---Framework imports
import { Actions } from 'uix/registries';
import log from 'uix/logging';
import { HeaderSegment } from 'uix/components';
//~ import {DomainCSSViewer} from 'uix/templating/css'
import { loadLazy } from 'uix/parts';
// ---Local imports
import { DomainConfigTable } from '../components';
import { configIcon } from './utils';
// ---Globals
const ConfigTable = (props)=>/*#__PURE__*/ _jsx(DomainConfigTable, {
        include: [],
        levels: "4",
        menu: true,
        menuPortal: "ConfigMenuPortal",
        ...props
    });
export const ShowConfig = ()=>/*#__PURE__*/ _jsx(HeaderSegment, {
        major: true,
        header: "Config",
        icon: configIcon('globe'),
        portal: "ConfigMenuPortal",
        overflowInner: true,
        flex: true,
        children: /*#__PURE__*/ _jsx(ConfigTable, {
            flex: true,
            section: "root",
            exclude: [
                'modsforms',
                'templating'
            ]
        })
    });
export const ShowFrontendConfig = ()=>/*#__PURE__*/ _jsx(HeaderSegment, {
        major: true,
        header: "Config",
        icon: configIcon('desktop'),
        portal: "ConfigMenuPortal",
        children: /*#__PURE__*/ _jsx(ConfigTable, {
            section: "templating"
        })
    });
export const EditCSS = loadLazy(()=>import(/* webpackChunkName: 'config' */ './domain_css'));
export const EditConfig = loadLazy(()=>import(/* webpackChunkName: 'config' */ './dconfig_editor'));
export const ConfigHistory = loadLazy(()=>import(/* webpackChunkName: 'config' */ './dconfig_history'));
export const DomainConfigChain = loadLazy(()=>import(/* webpackChunkName: 'config' */ './dconfig_chain'));
export const ConfigDashboard = loadLazy(()=>import(/* webpackChunkName: 'config' */ './dashboard'));
export const I18NDiag = loadLazy(()=>import(/* webpackChunkName: 'config' */ './i18ndiag'));
import { I18NTable } from '../i18nedit';
export const TestI18N = ({ dname })=>{
    return /*#__PURE__*/ _jsx(I18NTable, {
        dname: dname,
        flex: true
    });
};
